import ImgURL from "./assets/imgs/CourseBanner.png";

// Codewitheras Projects
export const projectData = [
  {
    id: 1,
    title: "Todo Mobile App",
    description:
      "Learn to build a To-do mobile application using react native by watching this tutorial project.",
    tag: "React Native",
    price: "free",
    stack: "React Native",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "beginner",
    sort: "beginner",
  },
  {
    id: 2,
    title: "Facebook Clone UI",
    description:
      "Learn to clone the famous social chatting application Facebook by watching this tutorial project.",
    tag: "Html",
    price: "free",
    stack: "React",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "advanced",
    sort: ["free", "intermediate", "advanced"],
  },
  {
    id: 3,
    title: "Dictionary App",
    description:
      "Learn to build a dictionary app by watching this tutorial project.",
    tag: "React Native",
    price: "free",
    stack: "Html",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "beginner",
    sort: ["free", "beginner"],
  },
  {
    id: 4,
    title: "Twitter Clone",
    description:
      "Learn to clone the famous social application Twitter by watching this tutorial project.",
    tag: "React",
    price: "free",
    stack: "React",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "intermediate",
    sort: ["free", "intermediate"],
  },
  {
    id: 5,
    title: "Netflix Clone",
    description:
      "Learn to clone the famous movies application Netflix by watching this tutorial project.",
    tag: "React",
    price: "free",
    stack: "React",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "intermediate",
    sort: ["free", "intermediate"],
  },
  {
    id: 7,
    title: "Instagram Clone",
    description:
      "Learn to clone the famous social application Instagram by watching this tutorial project.",
    tag: "React",
    price: "free",
    stack: "React",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "intermediate",
    sort: ["free", "intermediate"],
  },
  {
    id: 8,
    title: "Dictionary Application",
    description:
      "Learn to a dictionary application by watching this tutorial project.",
    tag: "Html",
    price: "free",
    stack: "Html",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "beginner",
    sort: ["free", "beginner"],
  },
  {
    id: 9,
    title: "Currency Convertor",
    description:
      "Learn to a currency convertor application intergrating currency API by watching this tutorial project",
    tag: "Html",
    price: "free",
    stack: "Html",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "beginner",
    sort: ["free", "beginner"],
  },
  {
    id: 10,
    title: "YouTube Clone",
    description:
      "Learn to clone the famous video streaming application intergrating YouTube API by watching this tutorial project.",
    tag: "React",
    price: "free",
    stack: "React",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "advanced",
    sort: ["free", "advanced"],
  },
  {
    id: 11,
    title: "Spotify Clone",
    description:
      "Clone the famous music streaming application intergrating Spotify API by watching this tutorial project.",
    tag: "React",
    price: "free",
    stack: "React",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "advanced",
    sort: ["free", "advanced"],
  },
  {
    id: 12,
    title: "Slack Clone",
    description:
      "Clone the famous team collaboration application Slack by watching this tutorial project.",
    tag: "React",
    price: "free",
    stack: "React",
    category: "html",
    coverImg: ImgURL,
    tutor: "Erasmus Mensah",
    level: "advanced",
    sort: ["free", "advanced"],
  },
];

// Codewitheras Project Templates to display to users
export const projectTemplates = [
  {
    id: 1,
    template_name: "Amazon Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 2,
    template_name: "Google Homepage Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 3,
    template_name: "YouTube Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 4,
    template_name: "Twitter Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 5,
    template_name: "Github Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 6,
    template_name: "Reddit Clone",
    template_desc:
      "j3shjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 7,
    template_name: "Spotify Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 8,
    template_name: "Slack Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 9,
    template_name: "Facebook Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 10,
    template_name: "Instagram Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 11,
    template_name: "TikTok Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 12,
    template_name: "Disney Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 13,
    template_name: "Telegram Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 14,
    template_name: "Google Docs Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 15,
    template_name: "Uber Eats Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 16,
    template_name: "Zoom Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 17,
    template_name: "Google Meets Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 18,
    template_name: "Netflix Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 19,
    template_name: "Hulu Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 20,
    template_name: "Todo App",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 21,
    template_name: "Dashboard",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 22,
    template_name: "LinkedIn Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 23,
    template_name: "Uber Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 24,
    template_name: "WhatsApp Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 25,
    template_name: "Discord Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 26,
    template_name: "Gmail Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 27,
    template_name: "Tesla Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 28,
    template_name: "SpaceX Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 29,
    template_name: "Dribbble Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
  {
    id: 30,
    template_name: "Pinterest Clone",
    template_desc:
      "jshjfhjfhdsjf sjhfjshfjhfjshfjsfhjkdfhl fjhsdjfhlsjfhlsfhsjflhd",
    level: "beginner",
    stack: ["react", "firebase", "Material Icons"],
    templateImgUrl: ImgURL,
    download_link: "",
  },
];

// Codewitheras Courses to display to users
export const courses = [];

// Codewitheras Resources for students
export const resources = [];

// Database for student project submission
export const projectsShowCase = [
  // {
  //   id: 1,
  //   student_name: "Erasmus Mensah",
  //   showCaseImg: ImgURL,
  //   title: "Real Estate",
  //   desc: "A real estate project built using HTML, CSS and JAVASCRIPT",
  //   deployed_link: "https://projectshowcase.netlify.app",
  //   github_repo_link: 'https://github.com/user-repo-name'
  // },
  // {
  //   id: 2,
  //   student_name: "Daniel Brown",
  //   showCaseImg: ImgURL,
  //   title: "E-commerce Mobile App",
  //   desc: "An E-commerce mobile app like Amazon",
  //   deployed_link: "https://projectshowcase.netlify.app",
  //   github_repo_link: 'https://github.com/user-repo-name'
  // },
  // {
  //   id: 3,
  //   student_name: "Angel Nyansafo",
  //   showCaseImg: ImgURL,
  //   title: "Dating App",
  //   desc: "A tinderlike clone",
  //   deployed_link: "https://projectshowcase.netlify.app",
  //   github_repo_link: 'https://github.com/user-repo-name'
  // },
  // {
  //   id: 4,
  //   student_name: "Kakra Arthur",
  //   showCaseImg: ImgURL,
  //   title: "",
  //   desc: "",
  //   deployed_link: "https://projectshowcase.netlify.app",
  //   github_repo_link: 'https://github.com/user-repo-name'
  // },
  // {
  //   id: 5,
  //   student_name: "Panyin Arthur",
  //   showCaseImg: ImgURL,
  //   title: "",
  //   desc: "",
  //   deployed_link: "https://projectshowcase.netlify.app",
  //   github_repo_link: 'https://github.com/user-repo-name'
  // }
];